import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchApi } from "Config/fetchApi";
import { handleError } from "Helper";

// Initial state
const initialState = {
  master: {
    datamasterTypePerangkat: [],
    isLoadingmasterTypePerangkat: false,
    errormasterTypePerangkat: null,

    datamasterOrganisasi: [],
    isLoadingmasterOrganisasi: false,
    errormasterOrganisasi: null,

    datamasterNamaOperasi: [],
    isLoadingmasterNamaOperasi: false,
    errormasterNamaOperasi: null,

    datamasterStatus: [],
    isLoadingmasterStatus: false,
    errormasterStatus: null,

    datamasterGender: [],
    isLoadingmasterGender: false,
    errormasterGender: null,

    datamasterNationality: [],
    isLoadingmasterNationality: false,
    errormasterNationality: null,
  },
};

// Thunk: getMasterTypePerangkat

const getMasterTypePerangkat = createAsyncThunk(
  "master/getMasterTypePerangkat",
  async (_, { rejectWithValue }) => {
    try {
      const api = fetchApi();
      const result = await api.get(`device-type/get-list`);
      return result?.data?.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Thunk: getMasterOrganisasi
const getMasterOrganisasi = createAsyncThunk(
  "master/getMasterOrganisasi",
  async (_, { rejectWithValue }) => {
    try {
      const api = fetchApi();
      const result = await api.get(`/organization/get-list`);
      return result?.data?.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Thunk: getMasterNamaOperasi
const getMasterNamaOperasi = createAsyncThunk(
  "master/getMasterNamaOperasi",
  async (_, { rejectWithValue }) => {
    try {
      const api = fetchApi();
      const result = await api.get(`/operation/get-list`);
      return result?.data?.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Thunk: getMasterStatus
const getMasterStatus = createAsyncThunk(
  "master/getMasterStatus",
  async (_, { rejectWithValue }) => {
    try {
      const api = fetchApi();
      const result = await api.get(`/operation-status/get-list`);
      return result?.data?.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Thunk: getMasterGender
const getMasterGender = createAsyncThunk(
  "master/getMasterGender",
  async (_, { rejectWithValue }) => {
    try {
      const api = fetchApi();
      const result = await api.get(`/gender/get-list`);
      return result?.data?.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Thunk: getMasterNationality
const getMasterNationality = createAsyncThunk(
  "master/getMasterNationality",
  async (_, { rejectWithValue }) => {
    try {
      const api = fetchApi();
      const result = await api.get(`/nationality-type/get-list`);
      return result?.data?.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Slice
const masterSlice = createSlice({
  name: "master",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // getMasterTypePerangkat
      .addCase(getMasterTypePerangkat.pending, (state) => {
        state.master.isLoadingmasterTypePerangkat = true;
        state.master.errormasterTypePerangkat = null;
      })
      .addCase(getMasterTypePerangkat.fulfilled, (state, action) => {
        state.master.isLoadingmasterTypePerangkat = false;
        state.master.datamasterTypePerangkat = action.payload || [];
        state.master.errormasterTypePerangkat = null;
      })
      .addCase(getMasterTypePerangkat.rejected, (state, action) => {
        state.master.isLoadingmasterTypePerangkat = false;
        state.master.errormasterTypePerangkat = action.payload;
      })

      // getMasterOrganisasi
      .addCase(getMasterOrganisasi.pending, (state) => {
        state.master.isLoadingmasterOrganisasi = true;
        state.master.errormasterOrganisasi = null;
      })
      .addCase(getMasterOrganisasi.fulfilled, (state, action) => {
        state.master.isLoadingmasterOrganisasi = false;
        state.master.datamasterOrganisasi = action.payload || [];
        state.master.errormasterOrganisasi = null;
      })
      .addCase(getMasterOrganisasi.rejected, (state, action) => {
        state.master.isLoadingmasterOrganisasi = false;
        state.master.errormasterOrganisasi = action.payload;
      })

      // getMasterNamaOperasi
      .addCase(getMasterNamaOperasi.pending, (state) => {
        state.master.isLoadingmasterNamaOperasi = true;
        state.master.errormasterNamaOperasi = null;
      })
      .addCase(getMasterNamaOperasi.fulfilled, (state, action) => {
        state.master.isLoadingmasterNamaOperasi = false;
        state.master.datamasterNamaOperasi = action.payload || [];
        state.master.errormasterNamaOperasi = null;
      })
      .addCase(getMasterNamaOperasi.rejected, (state, action) => {
        state.master.isLoadingmasterNamaOperasi = false;
        state.master.errormasterNamaOperasi = action.payload;
      })

      // getMasterStatus
      .addCase(getMasterStatus.pending, (state) => {
        state.master.isLoadingmasterStatus = true;
        state.master.errormasterStatus = null;
      })
      .addCase(getMasterStatus.fulfilled, (state, action) => {
        state.master.isLoadingmasterStatus = false;
        state.master.datamasterStatus = action.payload || [];
        state.master.errormasterStatus = null;
      })
      .addCase(getMasterStatus.rejected, (state, action) => {
        state.master.isLoadingmasterStatus = false;
        state.master.errormasterStatus = action.payload;
      })

      // getMasterGender
      .addCase(getMasterGender.pending, (state) => {
        state.master.isLoadingmasterGender = true;
        state.master.errormasterGender = null;
      })
      .addCase(getMasterGender.fulfilled, (state, action) => {
        state.master.isLoadingmasterGender = false;
        state.master.datamasterGender = action.payload || [];
        state.master.errormasterGender = null;
      })
      .addCase(getMasterGender.rejected, (state, action) => {
        state.master.isLoadingmasterGender = false;
        state.master.errormasterGender = action.payload;
      })

      // getMasterNationality
      .addCase(getMasterNationality.pending, (state) => {
        state.master.isLoadingmasterNationality = true;
        state.master.errormasterNationality = null;
      })
      .addCase(getMasterNationality.fulfilled, (state, action) => {
        state.master.isLoadingmasterNationality = false;
        state.master.datamasterNationality = action.payload || [];
        state.master.errormasterNationality = null;
      })
      .addCase(getMasterNationality.rejected, (state, action) => {
        state.master.isLoadingmasterNationality = false;
        state.master.errormasterNationality = action.payload;
      });
  },
});

export default masterSlice.reducer;

// Export all thunks
export {
  getMasterTypePerangkat,
  getMasterOrganisasi,
  getMasterNamaOperasi,
  getMasterStatus,
  getMasterGender,
  getMasterNationality,
};
